import * as angular from 'angular';

export const module = angular.module('permissionService', []);

export class PermissionService {
    canEditPaymentMethod(policyInfo: CustomerPolicyInfo) {
        // TODO: create policy status enum usable throughout Customer Portal
        const cancelledPolicyStatuses = ['terminated', 'expired'];
        // edit payment method is hidden only if policyInfo is in a cancelled status
        return !cancelledPolicyStatuses.includes(policyInfo.status);
    }
}

module.factory('permissionService', function() {
    return new PermissionService();
});
